export const TRIGGER_VIDEO_CHANGE = 'TRIGGER-VIDEO-CHANGE'

export const TRIGGER_SWING_TIMING_VISUAL_ADD = 'TRIGGER_SWING_TIMING_VISUAL_ADD'
